var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPredefinedModuleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.0002V5.99694C15.7498 5.80045 15.6981 5.60746 15.6001 5.43716C15.502 5.26686 15.3611 5.1252 15.1914 5.02628L9.84762 1.91636C9.59015 1.76647 9.29756 1.6875 8.99965 1.6875C8.70173 1.6875 8.40914 1.76647 8.15168 1.91636L2.80863 5.02628C2.63886 5.1252 2.49796 5.26686 2.39995 5.43716C2.30194 5.60746 2.25024 5.80045 2.25 5.99694V12.0002C2.25012 12.1968 2.30176 12.39 2.39977 12.5604C2.49779 12.7308 2.63876 12.8726 2.80863 12.9716L8.15238 16.0815C8.40992 16.2312 8.70248 16.31 9.00035 16.31C9.29822 16.31 9.59079 16.2312 9.84832 16.0815L15.1921 12.9716C15.3618 12.8725 15.5026 12.7307 15.6005 12.5603C15.6984 12.3899 15.75 12.1968 15.75 12.0002Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42578 5.41406L9 9.28125M9 9.28125L15.5742 5.41406M9 9.28125V16.3125",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredefinedModuleIcon);
export default __webpack_public_path__ + "static/media/predefined-module-icon.fcb48ca98b6b57d90e96186dc7135a44.svg";
export { ForwardRef as ReactComponent };